import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: "Vérifier l'éligibilité de l'adresse",
  or: 'ou',
  form: {
    company: {
      label: 'Sélectionner un restaurant',
    },
    address: {
      label: "Saisir l'adresse",
    },
  },
  result: {
    positive: '{{address}} est éligible à la livraison externe',
    negative: "{{address}} n'est pas éligible à la livraison externe",
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Vérifier',
  },
  toasts: {
    error: "Échec de la vérification de l'adresse",
  },
};
